<template>
  <div>
    <span v-if="publishable.is_published">
      <span
        :title="publishable.published_at"
        class="badge badge-info">
        Published
      </span>
    </span>
    <span v-if="!publishable.is_published">
      <span v-if="publishable.published_at">
        <span
          :title="publishable.published_at"
          class="badge badge-warning">
          {{ publishable.published_at.substr(0, 10) }}
        </span>
      </span>
      <span v-if="!publishable.published_at">
        <span class="badge badge-dark">
          Draft
        </span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'PublishedBadge',
  props: {
    publishable: {
      required: true,
      type: Object
    }
  }
}
</script>
